import {
  endOfMonth,
  endOfYear,
  startOfMonth,
  startOfYear,
  subDays,
  subMonths,
  subYears,
} from 'date-fns';
import { useMemo } from 'react';
import type { StaticRange } from 'react-date-range';
import { createStaticRanges } from 'react-date-range';

import { useGetFiscalYearStart } from './useGetFiscalYearStart';

export const useGetStaticRanges = (): StaticRange[] => {
  const fiscalYearStart = useGetFiscalYearStart();
  return useMemo(() => {
    return createStaticRanges([
      {
        label: 'Month to Date',
        range: () => ({
          startDate: startOfMonth(subDays(new Date(), 1)),
          endDate: subDays(new Date(), 1),
        }),
      },
      {
        label: 'Last 30 Days',
        range: () => ({
          startDate: subDays(new Date(), 30),
          endDate: subDays(new Date(), 1),
        }),
      },
      {
        label: 'Last Month',
        range: () => ({
          startDate: startOfMonth(subMonths(new Date(), 1)),
          endDate: endOfMonth(subMonths(new Date(), 1)),
        }),
      },
      {
        label: 'Last 3 Months',
        range: () => ({
          startDate: subMonths(new Date(), 4),
          endDate: subDays(new Date(), 1),
        }),
      },
      {
        label: 'Last 6 Months',
        range: () => ({
          startDate: subMonths(new Date(), 7),
          endDate: subDays(new Date(), 1),
        }),
      },
      {
        label: 'Last Year',
        range: () => ({
          startDate: startOfYear(subYears(new Date(), 1)),
          endDate: endOfYear(subYears(new Date(), 1)),
        }),
      },
      {
        label: 'Year to Date',
        range: () => ({
          startDate: startOfYear(subDays(new Date(), 1)),
          endDate: subDays(new Date(), 1),
        }),
      },
      {
        label: 'fiscal_year',
        range: () => ({
          startDate: fiscalYearStart,
          endDate: subDays(new Date(), 1),
        }),
        hasCustomRendering: true,
      },
      {
        label: 'Account Lifetime',
        range: () => ({
          startDate: new Date(2015, 0, 1),
          endDate: subDays(new Date(), 1),
        }),
      },
    ]);
  }, [fiscalYearStart]);
};
